const statusRequestEnum = Object.freeze({
  APPROVED: 1, // '00',
  NOT_REGISTERED: 2, // '01',
  PENDING_VERIFICATION: 3, // '02',
  USER_REGISTER_WITHOUT_BONIFICATION: 4, // '03',
  INCORRECT_USER_DATA: 5, // '04',
  BLOCKED_BY_MISUSE: 6, // '05',
});

export {
  statusRequestEnum,
};
